export function photoToUrl(photoId?: string | null): string {
  // TEMPORARY: If photoId starts with '/images/', use it directly as the URL. Delete this once 29x is no longer involved in development
  if (photoId && photoId.startsWith('/images/')) {
    return photoId;
  }
  // If photoId is present and not empty, use filestore path
  if (photoId && photoId.trim() !== '') {
    return `/filestore/${photoId}`;
  }
  // TEMPORARY: Default fallback image
  return '/images/event-photo-placeholder.jpg';
}